import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon from '../Icon';

import './styles.less';

class Dropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = { label: this.props.label ? this.props.label : '', value: '', isFocus: false };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const val = JSON.parse(event.target.value);
        this.setState({ value: event.target.value, label: val.label });
        this.props.onChange(this.props.useV2 ? val : val.value);
    }

    render() {
        return (
            <div
                className={classNames({
                    'p-dropdown': true,
                    'p-dropdown--focused': this.state.isFocus
                })}
            >
                <span className="p-dropdown__label">{this.props.useV2 ? this.props.label : this.state.label}</span>
                <div className="p-dropdown__arrow">
                    <Icon icon={this.props.icon ? this.props.icon : 'arrow-expand'} />
                </div>
                <select
                    className="p-dropdown__actual-select-element"
                    onChange={this.handleChange}
                    onFocus={() => this.setState({ isFocus: true })}
                    onBlur={() => this.setState({ isFocus: false })}
                    value={(this.props.selected === 'all') ? '' : this.state.value}
                >
                    {Object.keys(this.props.options).map((key) => {
                        return (
                            <option
                                key={key}
                                value={JSON.stringify({
                                    label: key,
                                    value: this.props.options[key],
                                    name: this.props.filterType ? this.props.filterType : this.props.label.toLowerCase().replace(/\s/gi, '_')
                                })}
                            >
                                {key}
                            </option>
                        );
                    })}
                </select>
            </div>
        );
    }
}

Dropdown.propTypes = {
    contentId: PropTypes.string,
    label: PropTypes.string, //Default ""
    filterType: PropTypes.string, //Default ""
    useV2: PropTypes.bool,
    selected: PropTypes.string, //Default ""
    icon: PropTypes.string, //Default "arrow-expand"
    options: PropTypes.shape({}).isRequired, //Key = string, Value = data
    onChange: PropTypes.func //Callback that takes a value of the same type as data.
};

Dropdown.defaultProps = {
    contentId: undefined,
    label: '',
    filterType: undefined,
    useV2: false,
    selected: '',
    icon: 'arrow-expand',
    onChange: undefined
};

export default Dropdown;
